import { isServer, QueryClient } from '@tanstack/react-query';
import { UnexpectedError } from '@wwe-portal/web/services/client/error';
import axios from 'axios';

export const makeQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 30, // 30 seconds
        gcTime: 1000 * 5, // 30 seconds
        retry: (failureCount, error) => {
          // Not retry on expected request error
          if (
            !(error instanceof UnexpectedError) ||
            !axios.isAxiosError(error.error)
          )
            return false;

          const axiosErrorResponseStatus = error.error.response?.status;
          // Not retry on 4xx error
          if (
            axiosErrorResponseStatus &&
            axiosErrorResponseStatus >= 401 &&
            axiosErrorResponseStatus < 500
          ) {
            return false;
          }

          // Retry when failure count is less than 3
          return failureCount < 3;
        },
        retryDelay: 10000,
        retryOnMount: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
      },
    },
  });

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    // Server: always make a new query client
    return makeQueryClient();
  } else {
    // Browser: make a new query client if we don't already have one
    // This is very important, so we don't re-make a new client if React
    // suspends during the initial render. This may not be needed if we
    // have a suspense boundary BELOW the creation of the query client
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}
